module.exports = __webpack_public_path__ + "img/open-link.fe3967f4.svg";